import { ChangeDetectionStrategy, Component, input, Input } from '@angular/core';
import { UntypedFormControl, FormsModule, ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { AssessmentRowComponent } from '../assessment-row/assessment-row.component';
import { EmrCheckboxGroupComponent } from "../../../../shared/emr-checkbox-group/emr-checkbox-group.component";
import { EmrInputComponent } from "../../../../shared/emr-input/emr-input.component";
import { WnlManagerService } from '../wnl-manager.service';

import { Patient } from 'src/app/calvin-emr-shared/models/patient.model';
import { EmrCheckboxComponent } from "../../../../shared/emr-checkbox/emr-checkbox.component";

import { FormOption } from 'src/app/shared/models/form-option.model';
import { GenitourinaryFormGroup } from 'src/app/calvin-emr-shared/models/assessments/genitourinary.model';

@Component({
  selector: 'app-genitourinary-form',
  templateUrl: './genitourinary-form.component.html',
  styleUrls: ['./genitourinary-form.component.scss', '../assessments-tab.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatCheckboxModule,
    FormsModule,
    ReactiveFormsModule,
    AssessmentRowComponent,
    EmrCheckboxGroupComponent,
    EmrInputComponent,
    EmrCheckboxComponent
  ],
})
export class GenitourinaryFormComponent {

  formGroup = input.required<GenitourinaryFormGroup>();
  patient = input.required<Patient>();

  wnlManager = new WnlManagerService();
  wnlManagerOB = new WnlManagerService();



  urineColorOptions = [
    new FormOption('Yellow'),
    new FormOption('Dark Yellow'),
    new FormOption('Blood Tinged'),
    new FormOption('WNL'),
  ];

  urineCharacteristicsOptions = [
    new FormOption('Cloudy'),
    new FormOption('Sediment'),
    new FormOption('Odor'),
  ];

  urinaryPatternOptions = [
    new FormOption('Frequency', 'frequency'),
    new FormOption('Nocturia', 'nocturia'),
    new FormOption('Dysuria', 'dysuria'),
    new FormOption('Incontinence', 'incontinence'),
    new FormOption('Retention', 'retention'),
  ];

  constructor() {
    this.reset();
  }

  reset() {
    this.wnlManager.setControls(
      [
        { control: 'urineColor', default: 'WNL', wnl: false },
        { control: 'urineCharacteristics', default: [], wnl: false },
        { control: 'urinaryPattern', default: [], wnl: false },
      ]
    );

    this.wnlManagerOB.setControls(
      [
        { control: 'urineColor', default: 'WNL', wnl: false },
        { control: 'urineCharacteristics', default: [], wnl: false },
        { control: 'urinaryPattern', default: [], wnl: false },
      ]
    );
  }

  get urineColorDefault() {
    return this.wnlManager.controlColl['urineColor'].default;
  }

  get urineCharacteristicsDefault() {
    return this.wnlManager.controlColl['urineCharacteristics'].default;
  }

  get urinaryPatternDefault() {
    return this.wnlManager.controlColl['urinaryPattern'].default;
  }


}
